module.exports = __webpack_public_path__ + "static/media/icon4.9deb0c43.jpg";